var DOMBuilder = /** @class */ (function () {
    function DOMBuilder(container, options) {
        this.root = globalThis.document.querySelectorAll(options.root);
        this.lightColorMode = options.lightColorMode;
        this.darkColorMode = options.darkColorMode;
        container.innerHTML = "";
        this.input = globalThis.document.createElement("input");
        this.input.type = "checkbox";
        container.appendChild(this.input);
        this.input.bootstrapToggle({
            onlabel: options.lightLabel,
            offlabel: options.darkLabel,
            onstyle: options.style,
            offstyle: options.style,
        });
    }
    DOMBuilder.prototype.setState = function (isLight) {
        var _this = this;
        this.input.bootstrapToggle(isLight ? BootstrapToggleMethods.ON : BootstrapToggleMethods.OFF, true);
        this.root.forEach(function (el) {
            el.dataset[DOMBuilder.BS_ATTRIBUTE] = isLight ? _this.lightColorMode : _this.darkColorMode;
        });
    };
    DOMBuilder.prototype.onChange = function (handler) {
        this.input.addEventListener("change", handler);
    };
    DOMBuilder.BS_ATTRIBUTE = "bsTheme";
    return DOMBuilder;
}());
export { DOMBuilder };
export var BootstrapToggleMethods;
(function (BootstrapToggleMethods) {
    BootstrapToggleMethods["ON"] = "ON";
    BootstrapToggleMethods["OFF"] = "OFF";
    BootstrapToggleMethods["TOGGLE"] = "TOGGLE";
    BootstrapToggleMethods["DETERMINATE"] = "DETERMINATE";
    BootstrapToggleMethods["INDETERMINATE"] = "INDETERMINATE";
    BootstrapToggleMethods["ENABLE"] = "ENABLE";
    BootstrapToggleMethods["DISABLE"] = "DISABLE";
    BootstrapToggleMethods["READONLY"] = "READONLY";
    BootstrapToggleMethods["DESTROY"] = "DESTROY";
    BootstrapToggleMethods["RENDERER"] = "RENDERER";
})(BootstrapToggleMethods || (BootstrapToggleMethods = {}));
